import { render, staticRenderFns } from "./SubscriptionExpress.vue?vue&type=template&id=52e94813&scoped=true"
import script from "./SubscriptionExpress.vue?vue&type=script&lang=ts"
export * from "./SubscriptionExpress.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionExpress.vue?vue&type=style&index=0&id=52e94813&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e94813",
  null
  
)

export default component.exports